"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _clsx = _interopRequireDefault(require("clsx"));

var _commonCta = require("@mmc/common-cta");

var _index = _interopRequireDefault(require("./index.css"));

var CommonErrorMessage = function CommonErrorMessage(_ref) {
  var theme = _ref.theme,
      errorTitle = _ref.errorTitle,
      errorContent = _ref.errorContent,
      viewHomePage = _ref.viewHomePage,
      viewHomePagePath = _ref.viewHomePagePath,
      className = _ref.className;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx["default"])(theme['container-wrapper'], _index["default"].errorContainer, className)
  }, errorTitle && /*#__PURE__*/_react["default"].createElement("p", {
    className: _index["default"].errorTitle
  }, errorTitle), errorContent && /*#__PURE__*/_react["default"].createElement("p", {
    className: _index["default"].errorContent
  }, errorContent), viewHomePage && viewHomePagePath && /*#__PURE__*/_react["default"].createElement(_commonCta.CommonCta, {
    theme: theme,
    data: {
      priority: 'low',
      label: viewHomePage,
      url: viewHomePagePath
    },
    classes: [_index["default"].goToHomeBtn, theme.textLinkUnderline]
  }));
};

var _default = CommonErrorMessage;
exports["default"] = _default;